import { Col, Pagination, Row, Space, Typography } from "antd";
import TopOptions from "./Components/TopOptions";
import { Fragment } from "react/jsx-runtime";
import NewsListItem from "../Common/NewsListItem";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { useGetNews } from "./ServerSideStates";
import NewsCartSkelton from "apps/Common/Skelton/NewsCartSkelton";
import CustomNoData from "apps/Common/CustomNoData";
import { MazakaButton } from "apps/Common/MazakaButton";
import { FilterOutlined } from "@ant-design/icons";

import PageTitle from '../../../Common/PageTitle';
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { handleResetNewsFitler } from "./ClientSideStates";




const NewsListIndex = () => {
  const { Text } = Typography;
  const dispatch = useDispatch();


  useEffect(() => {
    dispatch(handleResetNewsFitler()); // sayfa her açıldığında filtre sıfırlanır
  }, []);
 
  

  const { filter } = useSelector((state: RootState) => state.news);
  // const news = useGetNews(filter);
  const news = useGetNews({
      IncludeProperties: ["Media"],
    });
  console.log("news", news);
  return (
    <>
   
      <Col span={24} className="!py-8  !px-2 lg:!px-6 xxl:!px-16 !overflow-hidden" >
        <Row  gutter={[10, 20]}>
          <Col span={24} className="!flex justify-center">
          <PageTitle
          title={"Haber Listesi"}
          count={news.data?.data?.filteredCount}
          />
            
          </Col>
          <Col xs={24}>
            <Row gutter={[0, 20]}>
              <Col xs={24} >
              
                <TopOptions />
             
              </Col>
              <Col span={24}>
                <Row gutter={[0, 40]}>
                  <Col xs={24}>
                    <NewsCartSkelton
                      count={4}
                      loading={news.isLoading || news.isFetching}
                      rowCount={2}
                      customGutter={[40, 40]}
                    >
                      <>
                        {news?.data?.data?.data?.length > 0 ? (
                          <Row gutter={[40,40]}>
                            {news?.data?.data?.data?.map(
                              (item: any, index: number) => {
                                return (
                                  <Col xs={24} md={12} lg={6} key={index}>
                                    <NewsListItem item={item} />
                                  </Col>
                                );
                              }
                            )}
                          </Row>
                        ) : (
                          <>
                            <CustomNoData />
                          </>
                        )}
                      </>
                    </NewsCartSkelton>
                  </Col>
                  <Col xs={24} className="!flex !justify-center md:!justify-end">
                    <Pagination className="!px-0" />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      
    </>
  );
};

export default NewsListIndex;
